import { FilterInputData } from '../FilterTypes'
import type { Maybe, Aggregation } from '@pylot-data/pylotschema'

export const getConvertFilterDataToFilterHandler: (
    aggregationList: Maybe<Aggregation>[]
) => (criteria: FilterInputData) => FilterInputData = (
    availableAggregations
) => {
    return (criterion: FilterInputData) => {
        const aggregation_for_criterion = availableAggregations.filter(
            (agg) => agg?.attribute_code === criterion.requestVar
        )[0]
        const label = aggregation_for_criterion?.options?.filter(
            (option) => option?.value === criterion.value_string
        )[0]?.label
        return {
            requestVar: criterion.requestVar,
            value_string: criterion.value_string,
            label
        }
    }
}
